import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

// (function ($) {
// 	$(document).ready(function () {
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// Ownership
ScrollTrigger.create({
	trigger: "#ownership",
	// start: "top 50%",
	toggleActions: "play none none reverse",
	animation: tl,
});

gsap.to("#ownership1", {
	scrollTrigger: "#ownership",
	y: 0,
	duration: 2,
});

gsap.to("#ownership2", {
	scrollTrigger: "#ownership",
	y: 0,
	duration: 2,
});

gsap.to("#ownership3", {
	scrollTrigger: "#ownership",
	y: 0,
	duration: 2,
});

gsap.to("#ownership4", {
	scrollTrigger: "#ownership",
	y: 0,
	duration: 2,
});

// Growth

gsap.to(".growth-background", {
	scrollTrigger: ".growth-background",
	x: 0,
	duration: 0.5,
	// start: "top 50%",
});

// Productivity blub blubs
var tl = gsap.timeline();
tl.to("#productivityChart", {
	scale: 1,
	opacity: 1,
	duration: 0.25,
});
tl.to("#productivityChecklist", { scale: 1, opacity: 1, duration: 0.25 });
tl.to("#productivityCal", { scale: 1, opacity: 1, duration: 0.25 });

// Community headshots

ScrollTrigger.create({
	trigger: "#productivity",
	// start: "top 50%",
	toggleActions: "play none none reverse",
	animation: tl,
});

gsap.to("#communityImage1", {
	scrollTrigger: "#communityImage1",
	x: 0,
	duration: 0,
	delay: 0.5,
	opacity: 1,
});

gsap.to("#communityImage2", {
	scrollTrigger: "#communityImage1",
	x: 0,
	duration: 1,
	delay: 0.25,
	opacity: 1,
});

gsap.to("#communityImage3", {
	scrollTrigger: "#communityImage1",
	x: 0,
	duration: 1,
	delay: 0.5,
	opacity: 1,
});

gsap.to("#communityImage4", {
	scrollTrigger: "#communityImage1",
	x: 0,
	duration: 1,
	delay: 0.75,
	opacity: 1,
});

gsap.to("#communityImage5", {
	scrollTrigger: "#communityImage1",
	x: 0,
	duration: 1,
	delay: 1,
	opacity: 1,
});

// Counting Numbers for Pillars
let Cont = { val: 0 },
	NewVal = 500;

gsap.to(Cont, 0.5, {
	scrollTrigger: "#ownershipCount",
	val: NewVal,
	roundProps: "val",
	onUpdate: function () {
		document.getElementById("ownershipCount").innerHTML = Cont.val;
	},
});

let Cont2 = { val: 0 },
	NewVal2 = 50;

gsap.to(Cont2, 0.5, {
	scrollTrigger: "#communityCount",
	val: NewVal2,
	roundProps: "val",
	onUpdate: function () {
		document.getElementById("communityCount").innerHTML = Cont2.val;
	},
});

// Play Mosaik vid (@TODO break out into another js file)

ScrollTrigger.create({
	trigger: "#FeaturedSuccess",
	start: "top 50%",
	onEnter: function () {

		// callback for a single player
		// Add the UUID of the player you're trying to reference where indicated
		// window.onVidyardAPI = (vidyardEmbed) => {
			vidyardEmbed.api.addReadyListener((_, player) => {

				// console.log('player ready:', player.ready());
				// console.log(player.uuid);
				player.play();
				// put your code here

			}, "2A8pk7Amyd58HSDrU9EwFS") // Mosaik video
		// }
	},
});
// 	});
// })(jQuery);
